module.exports = __webpack_public_path__ + "img/fado-em-si.27fcbb97.jpg";